module.exports = __webpack_public_path__ + "img/color.c7a33805.png";